module.exports = __webpack_public_path__ + "img/3d-glasses-1.8e3d870c.png";